import Box from "@/common/components/Box";
import Button from "@/common/components/Button";
import TextField from "@/common/components/TextField";
import { ChevronsRight } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import GoBackButton from "@/common/components/GoBackButton";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import useTrackerIntegration from "../../../hooks/trackerIntegrations/useTrackerIntegration";
import Checkbox from "@/common/components/Checkbox";
import useCompany from "@/common/hooks/queries/useCompany";

const Show = () => {
  const { companyId, id } = useParams();

  const { data: company } = useCompany({ id: companyId || '' })

  const {
    data: initialTrackerIntegration,
    isPending: initialTrackerIntegrationIsPending,
    error: initialTrackerIntegrationError = {} as any,
    refetch: refetchTrackerIntegration,
  } = useTrackerIntegration(id || '');

  const disableUpdateButton = initialTrackerIntegrationIsPending || initialTrackerIntegrationError?.status === 403;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback={`/companies/${companyId}/tracker-integrations`} searchLastRouteFromFallback />

          <p className="text-white-400 font-normal">
            {company?.general_information?.fantasy_name}
          </p>

          <ChevronsRight color='#ffffffb3' />

          <h2>
            {initialTrackerIntegration?.option.display_name}
          </h2>
        </div>

        <Link
          to={disableUpdateButton ? '' : `/companies/${companyId}/tracker-integrations/${id}/edit`}
          className={disableUpdateButton ? "cursor-default" : ''}
        >
          <Button operationKlassToCheckPermission="Admin::Client::TrackerIntegrations::Update" data-testid='update_tracker_integration_button' type="submit" className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]" disabled={disableUpdateButton}>
            Editar
          </Button>
        </Link>
      </div>

      {initialTrackerIntegrationIsPending ? (
        <Box>Carregando...</Box>
      ) : (
        <ErrorMessageWrapper
          className="max-h-[calc(100vh-128px)]"
          statusCode={initialTrackerIntegrationError?.status}
          refetchFunction={refetchTrackerIntegration}
        >
          <Box className="flex flex-col gap-4 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
            <p className="text-lg font-bold">
              {initialTrackerIntegration?.option.display_name}
            </p>

            <TextField
              label="Tipo de integração"
              value={initialTrackerIntegration?.option.provider_klass}
              data-testid="option_id_selector"
              disabled
            />

            <div className="grid grid-cols-2 gap-y-4 gap-x-2">
              {initialTrackerIntegration?.parameters &&
                Object.keys(initialTrackerIntegration?.parameters)
                  .sort((a, b) => a.localeCompare(b))
                  .map((param) => (
                    <TextField
                      label={param}
                      name={`parameters.${param}`}
                      value={initialTrackerIntegration?.parameters[param]}
                      disabled
                    />
                  ))}
            </div>

            <Checkbox
              label="Habilitada"
              name="active"
              checked={initialTrackerIntegration?.active}
              disabled
            />
          </Box>
        </ErrorMessageWrapper>
      )}

    </div>
  );
};

export default Show;
